import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Theme/Common'

export const Header = styled.div({
  display: 'flex',
  flexDirection: 'column',
  padding: `${spacing.smx1} ${spacing.md}`,
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: '0.625rem',
  background: colors.studio[700],
})

export const Container = styled.div({
  display: 'flex',
  padding: `${spacing.md} ${spacing.md} ${spacing.sm} ${spacing.md}`,
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: '1rem',
  background: colors.white,
})

export const TopMessage = styled.div({
  display: 'flex',
  padding: 0,
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: spacing.smx2,
  alignSelf: 'stretch',
})

export const Title = styled.div({
  color: colors.black,
  fontFamily: font.family.primary,
  ...font.size.xl,
  fontStyle: 'normal',
  fontWeight: font.weight.semibold,
})

export const Explainer = styled.div({
  color: colors.neutral['800'],
  fontFamily: font.family.primary,
  ...font.size.lg,
  fontStyle: 'normal',
  fontWeight: font.weight.regular,
})

export const InfoCard = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: spacing.smx1,
  flexShrink: 0,
})

export const InfoCardHeading = styled.div({
  display: 'flex',
  padding: 0,
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: spacing.smx2,
  flex: '1 0 0',
})

export const InfoCardClose = styled.button({
  display: 'flex',
  padding: spacing.smx1,
  borderRadius: '40px',
  border: `1px solid ${colors.surface[200]}`,
  background: colors.surface[200],
})

export const Distance = styled.div({
  '> span': { fontWeight: font.weight.semibold },
})

const listNoticesStyles = {
  paddingLeft: spacing.big,
  marginTop: spacing.smx1,
  marginBottom: '0',
}
export const ListNotices = styled.ul(listNoticesStyles)
export const ListNoticesOrdered = styled.ol(listNoticesStyles)

export const Divider = styled.div({
  display: 'flex',
  alignItems: 'center',
  color: colors.neutral['500'],
  fontFamily: font.family.primary,
  ...font.size.md,
  fontWeight: font.weight.regular,
  margin: spacing.sm,

  '&::before, &::after': {
    content: "''",
    flex: 1,
    borderBottom: `1px solid ${colors.neutral['300']}`,
  },

  '&::before': {
    marginRight: spacing.sm,
  },

  '&::after': {
    marginLeft: spacing.sm,
  },
})

export const CollapsibleText = styled.div<{ isExpanded: boolean }>(({ isExpanded }) => ({
  display: 'block',
  maxHeight: isExpanded ? 'none' : '4.5rem',
  overflow: 'hidden',
  position: 'relative',
  transition: 'max-height 0.3s ease-in-out',
}))
export const ReadMoreButton = styled.div({
  cursor: 'pointer',
  textDecoration: 'underline',
})
